import React, { useRef, useState } from "react";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { SetTimeouService } from "namirasoft-core";

export interface NSCopyProps extends IBaseComponentProps
{
	children: React.ReactNode;
	value?: string;
}

export interface NSCopyState
{
	copied: boolean;
}

export function NSCopy(props: NSCopyProps)
{
	let NSCopyParent_ref = useRef<HTMLDivElement>(null);
	const service = useRef<SetTimeouService>(new SetTimeouService());

	let [state, setState] = useState<NSCopyState>({ copied: false });

	function onCopy(e: React.MouseEvent<HTMLImageElement>): void
	{
		e.stopPropagation();

		if (NSCopyParent_ref.current)
		{
			let value = props.value ?? NSCopyParent_ref.current?.innerText;
			navigator.clipboard.writeText(value);

			setState({ copied: true });
			service.current?.setTimeoutIfNotCalledAgain(() => { setState({ copied: false }) }, 3000);
		}
	}

	return (
		<div
			ref={NSCopyParent_ref}
			id={props.id}
			className={`d-flex align-items-center ${props.classList?.join(" ") ?? ""}`}
			style={props.style}
		>
			<div>
				{props.children}
			</div>
			<img src={state.copied ? "https://static.namirasoft.com/image/concept/check/on/blue.svg" : "https://static.namirasoft.com/image/concept/copy/blue.svg"}
				alt='Copy'
				width={16}
				height={16}
				onClick={onCopy}
				style={{
					cursor: "pointer",
					marginLeft: "4px"
				}}
			/>
		</div>
	);
}